export default __webpack_public_path__ + "static/media/gen2logo.041d2178.png";